import { useState } from "react";
import { useApi } from "../../utils/api/useApi";
import { verificationCodeEndpoint } from "../../utils/api/urls";

export const useSubmitCode = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { get } = useApi<any>();

  const submitCode = async (code: string, workflowId: string) => {
    setLoading(true);
    setError(null);
    try {
      if (!workflowId) {
        throw new Error("WorkflowId is required.");
      }
      const url = `${verificationCodeEndpoint}/${code}`;
      await get(url, {
        headers: {
          "X-Kamstrup-WorkflowId": workflowId
        }
      });
    } catch (err: any) {
      setError(err.message || "Failed to verify code.");
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { submitCode, loading, error };
};
